<div class="container-fluid py-4">
  <!-- Title Section -->
  <div class="text-center mb-4">
    <h3 class="fw-bold text-gradient">🎖️ Sponsor Details</h3>
    <p class="text-muted">Manage sponsorship records and payment statuses</p>
  </div>

  <!-- Note, Add Sponsor, Search -->
  <div class="row gy-3 align-items-center justify-content-between mb-4 text-center text-md-start">
    <!-- Note -->
    <div class="col-12 col-md-4">
      <p class="mb-0">
        <strong>Note<span class="text-danger">*</span>:</strong>
        Update view/payment status only if payment is
        <span class="text-danger fw-semibold">Not Paid</span>.
      </p>
    </div>

    <!-- Add Button -->
    <div class="col-12 col-md-3 text-md-end">
      <button class="btn btn-success rounded-pill w-100 w-md-auto" data-bs-toggle="modal"
        data-bs-target="#sponsorModal2" (click)="openModal()">
        <i class="bi bi-person-plus me-2"></i>Add New Sponsor
      </button>
    </div>

    <!-- Search -->
    <div class="col-12 col-md-3">
      <input type="text" class="form-control stylish-input" [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
        placeholder="Search sponsor by name or email..." />
    </div>
  </div>


  <!-- Sponsor Table -->
  <div class="card glass-card border-0 shadow p-3">
    <div class="table-responsive table-scroll-wrapper">
      <table class="table table-hover align-middle text-center mb-0 stylish-table">
        <thead class="table-header text-white">
          <tr>
            <th class="text-center">Sr.No</th>
            <th class="text-center">Sponsor Name</th>
            <th class="text-center">Email</th>
            <th class="text-center">Phone</th>
            <th class="text-center">Company</th>
            <th class="text-center">Location</th>
            <th class="text-center">Type</th>
            <th class="text-center">Payment Status <span class="text-danger">*</span></th>
            <th class="text-center">Logo</th>
            <th class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sponsor of filteredSponsors; let i = index">
            <td class="text-center">{{ i + 1 }}</td>
            <td class="text-center">{{ sponsor.companyName }}</td>
            <td class="text-center">{{ sponsor.emailAddress }}</td>
            <td class="text-center">{{ sponsor.phoneNumber }}</td>
            <td class="text-center">{{ sponsor.companyName }}</td>
            <td class="text-center">{{ sponsor.location }}</td>
            <td class="text-center">{{ sponsor.sponsorType }}</td>
            <td class="text-center">
              <span class="badge" [ngClass]="{
                  'bg-danger': sponsor.paymentStatus !== 'PAID',
                  'bg-success': sponsor.paymentStatus === 'PAID'
                }" (click)="paymentUpdate(sponsor.paymentStatus, sponsor.sponsorDetailsId)" style="cursor: pointer;">
                {{ sponsor.paymentStatus === 'PAID' ? 'Paid' : 'Not Paid' }}
              </span>
            </td>
            <td class="text-center">
              <i class="bi bi-download text-success fs-5" (click)="previewLogo(sponsor.sponsorDetailsId)"
                title="Sponsor Logo" style="cursor: pointer;"></i>
            </td>
            <td class="text-center">
              <select class="form-select stylish-input" [value]="sponsor.status"
                (change)="onStatusChange($event, sponsor.sponsorDetailsId, i)">
                <option value="ACTIVE">Active</option>
                <option value="INACTIVE">Inactive</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Sponsor Payment Modal -->
  <div class="modal" id="sponsorModal" [style.display]="adminSponsorModal ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header bg-success text-white">
          <h5 class="modal-title">Transaction Details</h5>
          <button type="button" class="btn-close btn-close-white" aria-label="Close"
            (click)="openingSponsor()"></button>
        </div>
        <div class="modal-body">
          <div class="alert alert-warning d-flex align-items-center mb-3" *ngIf="!selectedSponsor?.paymentStatus">
            <i class="bi bi-info-circle-fill me-2"></i>
            No transaction details available.
          </div>

          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <h6 class="card-title mb-3 d-flex align-items-center">
                <i class="bi bi-pencil-square text-primary me-2 fs-5"></i>
                Update Payment Status
              </h6>

              <div class="mb-3">
                <label class="form-label fw-semibold">Select Payment Status</label>
                <select class="form-select" [(ngModel)]="newPaymentStatus">
                  <option value="PAID">Paid</option>
                  <option value="NOT_PAID">Not Paid</option>
                </select>
              </div>

              <button class="btn btn-success rounded-pill px-4" (click)="confirmPaymentUpdate()">
                <i class="bi bi-save me-2"></i>Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Sponsor Create Modal -->
  <div class="modal fade" id="sponsorModal2" tabindex="-1" aria-labelledby="sponsorModalLabel2" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-3">
        <div class="modal-header">
          <h5 class="modal-title fw-bold text-success">Enter {{ sponsorType }} Sponsorship Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <form [formGroup]="addSponsorForm" (ngSubmit)="onSubmit()">
          <div class="modal-body px-2 px-md-4">

            <!-- First/Last Name -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="firstName" placeholder="First Name" />
                  <label>First Name</label>
                  <span *ngIf="addSponsorFormErrors.firstName" class="text-danger">{{ addSponsorFormErrors.firstName
                    }}</span>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="lastName" placeholder="Last Name" />
                  <label>Last Name</label>
                  <span *ngIf="addSponsorFormErrors.lastName" class="text-danger">{{ addSponsorFormErrors.lastName
                    }}</span>
                </div>
              </div>
            </div>

            <!-- Email & Phone -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="email" class="form-control" formControlName="emailAddress" placeholder="Email" />
                  <label>Email</label>
                  <span *ngIf="addSponsorFormErrors.emailAddress" class="text-danger">{{
                    addSponsorFormErrors.emailAddress }}</span>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="number" class="form-control" formControlName="phoneNumber" placeholder="Phone" />
                  <label>Phone</label>
                  <span *ngIf="addSponsorFormErrors.phoneNumber" class="text-danger">{{ addSponsorFormErrors.phoneNumber
                    }}</span>
                </div>
              </div>
            </div>

            <!-- Company & Location -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="companyName" placeholder="Company" />
                  <label>Company</label>
                  <span *ngIf="addSponsorFormErrors.companyName" class="text-danger">{{ addSponsorFormErrors.companyName
                    }}</span>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="text" class="form-control" formControlName="location" placeholder="Location" />
                  <label>Location</label>
                  <span *ngIf="addSponsorFormErrors.location" class="text-danger">{{ addSponsorFormErrors.location
                    }}</span>
                </div>
              </div>
            </div>

            <!-- Sponsor Type & Logo Upload -->
            <div class="row">
              <div class="col-md-6 mb-3 position-relative">
                <div class="form-floating">
                  <select class="form-select" formControlName="sponsorType">
                    <option value="" disabled>Select Sponsor Type</option>
                    <option value="Platinum">Platinum ($500)</option>
                    <option value="Gold">Gold ($250)</option>
                    <option value="Silver">Silver ($100)</option>
                  </select>
                  <label>Sponsor Type</label>
                  <span *ngIf="addSponsorFormErrors.sponsorType" class="text-danger">{{ addSponsorFormErrors.sponsorType
                    }}</span>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="form-floating">
                  <input type="file" class="form-control" formControlName="logo" (change)="onFileSelected($event)" />
                  <label>Logo or Image</label>
                  <span *ngIf="addSponsorFormErrors.logo" class="text-danger">{{ addSponsorFormErrors.logo }}</span>
                </div>
              </div>
            </div>

            <!-- Paid Status -->
            <div class="mb-3">
              <label class="form-label fw-semibold">Paid Status:</label>
              <div class="d-flex gap-3">
                <div class="form-check">
                  <input type="radio" class="form-check-input" formControlName="paymentStatus" value="PAID" id="paid" />
                  <label class="form-check-label" for="paid">Yes</label>
                </div>
                <div class="form-check">
                  <input type="radio" class="form-check-input" formControlName="paymentStatus" value="NOT_PAID"
                    id="notPaid" />
                  <label class="form-check-label" for="notPaid">No</label>
                </div>
              </div>
            </div>

            <!-- Submit -->
            <div class="text-center">
              <button type="submit" class="btn btn-success rounded-pill px-5 py-2">
                <i class="bi bi-check-circle me-2"></i>Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Spinner -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
  <div class="loader">
    <div class="inner one"></div>
    <div class="inner two"></div>
    <div class="inner three"></div>
  </div>
</ngx-spinner>
</div>